//
import Model from '@/models/Model'

/**
* This class describes a pch provider account bank.
* @class PchProviderAccountBank (name)
*/
export default class PchProviderAccountBank extends Model {

  /**
   * { item_description }
   */
  static includes = [
    'g_bank',
  ]

  /**
   * { property_description }
   * @type {<type>}
   */
  get account_number_bank() {
    return this.account_number + ' - ' + this.g_bank_bank
  }

  /**
   * { property_description }
   * @type {<type>}
   */
  get g_bank_bank() {
    return this.getProperty('g_bank.bank', '')
  }

  /**
   * { property_description }
   * @type {<type>}
   */
  get g_type_account_bank_type() {
    return this.getProperty('g_type_account_bank.type', '')
  }

  /**
   * { property_description }
   * @type {<type>}
   */
  get pch_provider_alias_name() {
    return this.getProperty('pch_provider.alias_name', '')
  }

  /**
   * { function_description }
   * @return {string}  { description_of_the_return_value }
   */
  resource() {
    return 'pch_provider_account_bank'
  }

  /**
   * Returns a create representation of the object.
   * @return     {<type>}  Create representation of the object.
   */
  toCreate() {
    return this.clean([
      'account_number',
      'email',
      'g_bank_id',
      'g_type_account_bank_id',
    ])
  }

  /**
   * Returns a create representation of the object.
   * @return     {<type>}  Create representation of the object.
   */
  toUpdate() {
    return this.clean([
      'account_number',
      'email',
      'g_bank_id',
      'g_type_account_bank_id',
    ])
  }
}
